import { ReactNode } from 'react';
import { Layout } from '@/common/components/layout/Layout';
import { NavMenu } from '@/features/navigation/components/nav-menu/NavMenu';
import { UserMenu } from '@/features/navigation/components/user-menu/UserMenu';
import { RouterBreadcrumbs } from '@/features/navigation/components/router-breadcrumbs/RouterBreadcrumbs';
import { ErrorBoundary } from '@/common/components/error-boundary/ErrorBoundary';

export interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <Layout topBarLeft={<RouterBreadcrumbs />} topBarRight={<UserMenu />} sidebar={<NavMenu />}>
      <ErrorBoundary>
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="mx-auto max-w-6xl">{children}</div>
        </div>
      </ErrorBoundary>
    </Layout>
  );
}
